import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {
  constructor(private http: HttpClient) {}

 
  getClients(perpage: any,page:any): Observable<any> {
    const body = new FormData();
    body.append('per_page', perpage);
    return this.http.post(`${environment.Server_URL}/clients?page=${page}`, body);
  }
   getClientsUserLvl(perpage: any,page:any,userId:any): Observable<any> {
    const body = new FormData();
    body.append('per_page', perpage);
    body.append('user_id', userId);
    return this.http.post(`${environment.Server_URL}/clients/users?page=${page}`, body);
  }
  delete(id:string):Observable<any>{
    return this.http.delete(environment.Server_URL+'/delete/stock/'+id);
  }
  searchClinet(serachkey: any): Observable<any> {
    const params = new HttpParams().set('phone', serachkey);
    return this.http.get(`${environment.Server_URL}/search-clients`, { params });
  }
}
